/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type RequestModalSelectProject_user$ref = any;
export type RequestModalSelectProject_user = {
    readonly serviceId: string | null;
    readonly tradeFirm: {
        readonly serviceId: string | null;
    } | null;
    readonly " $refType": RequestModalSelectProject_user$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "RequestModalSelectProject_user",
        "type": "User",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradeFirm",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmType",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'e10ff61e7ab9bd1c47790d7610ad35c1';
export default node;
